<template>
  <div class="box2">
   <img src="../../../assets/coursePage/trainer/02.png"/>
  </div>
</template>

<script>


export default {
 
  data() {
    return {
 
    };
  },
};
</script>

<style lang="less" scoped>
.box2 {
  width: 100%;
 img{
  width: 100%;
  display: block;
 }
  
}
</style>
